import { render, staticRenderFns } from "./jobdetailsdetinfo.vue?vue&type=template&id=53f0b268"
import script from "./jobdetailsdetinfo.vue?vue&type=script&lang=js"
export * from "./jobdetailsdetinfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports